import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Faces from '../components/Faces';


function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Faces));



// WEBPACK FOOTER //
// ./src/components/Steps/Faces/container/index.js